// Base de los servicios. Por defecto es el mismo dominio donde se publica el front
// (ej. https://cajas.roitgm.com/caja-ahorro/); se puede cambiar al compilar con REACT_APP_API_BASE_URL.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || `${window.location.origin}/caja-ahorro/`;

const API_URL_TRANSACTION = `${API_BASE_URL}transaccional-ws-0.1/`;
const API_URL_CREDIT = `${API_BASE_URL}credito-ws-0.1/`;
const API_URL_PERSON = `${API_BASE_URL}personas-ws-0.1/`;
const API_URL_SECURITY = `${API_BASE_URL}seguridades-ws-0.1/`;
const API_URL_REPORTS = `${API_BASE_URL}reporteria-ws-0.1/`;
const API_URL = `${API_BASE_URL}seguridades-ws-0.1/`;
//Nuevos V2
const API_URL_TESORERIA = `${API_BASE_URL}tesoreria-ws-0.1/`;
const API_URL_CONTABILIDAD = `${API_BASE_URL}contable-ws-0.1/`;

const EndPoints = {
   /* Login*/
   login: `${API_URL_SECURITY}security/login`,
   JWTRefresh: `${API_URL_SECURITY}security/JWTRefresh`,
   /**
    * Security
    */
   userList: `${API_URL_SECURITY}user/userEntity`,
   listUserType: `${API_URL_SECURITY}user/listUserType`,
   //Person
   listPerson: `${API_URL_PERSON}person/listPerson`,
   obtienePersonCodigo: `${API_URL_PERSON}person/obtienePersonaNatural`,
   savePersonBasic: `${API_URL_PERSON}person/savePersonBasic`,
   updatePerson: `${API_URL_PERSON}person/updateInformacionPersona`,
   validaExistePersona: `${API_URL_PERSON}person/validaExistePersona`,
   // INFORMACION PERSONA
   obtieneDatosSocio: `${API_URL}ingresoPersona/validaSocio`,
   // TIPO PERIODICIDAD
   obtieneTipoPeriodicidad: `${API_URL_CREDIT}credito/tipoPeriocidad`,
   // DATOS CUENTA EXTERNA
   listCuentasExternas: `${API_URL_CREDIT}credito/ifipExterna`,
   // PRODUCTO TASA
   listProductoTasa: `${API_URL_CREDIT}credito/listaProductoTasa`,
   // SERVICIO SOLCITUD DE CREDITO
   listTipoCuentas: `${API_URL_CREDIT}credito/tipoCuentaExterna`,

   listDestinoOpeCredito: `${API_URL_CREDIT}credito/destinoCredito`,
   // ENDPOINT SERVICIOS CAJA
   listTipoProducto: `${API_URL_TRANSACTION}transaccion/productoActFin`,
   // REGISTRO DATOS CREDITO
   verificaSolicitudCreditoIdentificacion: `${API_URL_CREDIT}credito/operacionCrediticia`,
   operacionCrediticiaNueva: `${API_URL_CREDIT}credito/operacionCrediticiaNueva`,

   saveCredito: `${API_URL_CREDIT}credito/guardaCredito`,
   // DATOS GARANTES
   consultagarantesOperacionCrediticia: `${API_URL_CREDIT}credito/consultaGarantesOperacionCrediticia`,
   saveGarantes: `${API_URL_CREDIT}credito/guardaGarantia`,
   // DATOS TABKA DE AMORTIZACION
   obtieneTablaAmortizacion: `${API_URL_CREDIT}credito/generaTabla`,
   // OBTIENE DATOS DE NUMERO DE CUENTA
   obtieneDatosCuenta: `${API_URL_TRANSACTION}socio/obtieneSocioCuenta`,
   obtieneDatosCuentaIdentificacion: `${API_URL_TRANSACTION}socio/obtieneSocioCuentaIdentificacion`,
   //obtieneTipoTransaccion: `${API_URL}transaccion/transaccionProducto`
   obtieneTipoTransaccion: `${API_URL_TRANSACTION}transaccion/obtieneTransaccionProducto`,
   listTipoTransaccion: `${API_URL_TRANSACTION}transaccion/listaTransaccion`,
   listIdentificacionType: `${API_URL_PERSON}catalog/idType`,
   listPersonTypes: `${API_URL_PERSON}catalog/personType`,
   saveMovimiento: `${API_URL_TRANSACTION}transaccion/saveMovimientos`,
   saveMovimientoCredito: `${API_URL_TRANSACTION}transaccion/saveMovimientosCredito`,
   saveMovimientoArchivoLote: `${API_URL_TRANSACTION}transaccion/saveMovimientosArchivoLote`,
   //Socios
   listadoSocio: `${API_URL_TRANSACTION}socio/getListadoSocio`,
   //Cuentas
   listadoCuentas: `${API_URL_TRANSACTION}transaccion/obtiene`,
   //Estado Cuentas
   listadoMovimientos: `${API_URL_TRANSACTION}transaccion/getEstadoCuenta`,
   listadoMovimientosFecha: `${API_URL_TRANSACTION}transaccion/getEstadoCuentaFecha`,

   asignaCuentas: `${API_URL_TRANSACTION}transaccion/asignaCuenta`,
   saveSocio: `${API_URL_TRANSACTION}socio/saveSocio`,
   //catalogos
   catalogos: `${API_URL_PERSON}catalog/listCatalogo`,
   listTipoVivienda: `${API_URL_PERSON}catalog/listTipoVivienda`,
   listEntidades: `${API_URL_SECURITY}security/login/ifip`,
   listCatalogoFlujoPatrimonio: `${API_URL_PERSON}catalog/listCatalogoFlujoPatrimonio`,
   listPersonaFlujoEfectivo: `${API_URL_PERSON}perFlujoEfectivo/listPersonaFlujoEfectivo`,
   addFlujoEfectivo: `${API_URL_PERSON}perFlujoEfectivo/addFlujoEfectivo`,
   listCriterioCredito: `${API_URL_CREDIT}credito/criterioCredito`,
   saveCriterioCredito: `${API_URL_CREDIT}credito/saveCriterioCredito`,

   getDirecciones: `${API_URL_PERSON}address/personAddress`,
   savePersonAddress: `${API_URL_PERSON}address/saveAddress`,
   getDivisionPolitica: `${API_URL_PERSON}catalog/divisionPolitica`,
   //ACTIVIDAD ECONOMICA
   listaActividadesEconomicas: `${API_URL_PERSON}catalog/listActividadEconomica`,

   // TIPO ACREDITACION
   listTipoAcreditacion: `${API_URL_CREDIT}credito/tipoAcreditacion`,
   // Persona Actividad Economica
   listPersonaActividadEconomica: `${API_URL_PERSON}perActividadEconomica/listPersonaActividadEconomica`,
   addActividadEconomica: `${API_URL_PERSON}perActividadEconomica/addActividadEconomica`,
   // OBTIENE DATOS DE CREDITO Y CUOTA A PAGAR
   obtieneSocioCredito: `${API_URL_CREDIT}credito/obtieneSocioCredito`,
   obtienePersonaIdentificacion: `${API_URL_PERSON}person/obtienePersona`,
   apruebaNiega: `${API_URL_CREDIT}credito/apruebaNiega`,
   // telefono
   obtienePersonaTelefono: `${API_URL_PERSON}phoneRecord`,
   addTelefono: `${API_URL_PERSON}phoneRecord/save`,
   listProfesion: `${API_URL_PERSON}catalog/listProfesion`,
   listNivelAcademico: `${API_URL_PERSON}catalog/listNivelAcademico`,
   // conyuge
   addConyuge: `${API_URL_PERSON}person/saveConyuge`,
   getConyuge: `${API_URL_PERSON}person/getConyuge`,
   getInformacionConyuge: `${API_URL_PERSON}person/conyuge`,
   obtieneConyugeIdentificacion: `${API_URL_PERSON}person/obtieneConyuge`,


   //apertura caja
   consultarAperturaCaja: `${API_URL_TRANSACTION}transaccion/consultarAperturaCaja`,
   aperturaCaja: `${API_URL_TRANSACTION}transaccion/aperturaCaja`,

   //Impresiones
   imprimirSocio: `${API_URL_REPORTS}socio/imprime`,

   //Nuevos para la version 2
   obtieneValoresPendientesCredito: `${API_URL_CREDIT}credito/obtieneSocioCreditoValores`,
   saveMovimientosCreditoAnticipo: `${API_URL_TRANSACTION}transaccion/saveMovimientosCreditoAnticipo`,

   //Tesoreria
   listRegitroGastos: `${API_URL_TESORERIA}tesoreria/listarRegistroGastos`,
   guardarRegistroGastos: `${API_URL_TESORERIA}tesoreria/guardarRegistroGastos`,

   //Contabilidad
   listaPlanCuenta: `${API_URL_CONTABILIDAD}contable/listaPlanCuenta`,
   savePlanCuenta: `${API_URL_CONTABILIDAD}contable/savePlanCuenta`,

   listaProcesoContable: `${API_URL_CONTABILIDAD}contable/listaProcesoContable`,
   saveProcesoContable: `${API_URL_CONTABILIDAD}contable/saveProcesoContable`,

   listaDetailProcesoContable: `${API_URL_CONTABILIDAD}contable/listaDetailProcesoContable`,
   saveDetailProcesoContable: `${API_URL_CONTABILIDAD}contable/saveDetailProcesoContable`,

   //Reportes
   balanceGeneal: `${API_URL_REPORTS}reporte/balanceGeneral`,
   

   
};
export default EndPoints;